import React, {Component} from 'react'
import {Icon, Modal, Popup, Checkbox, Button, Grid} from 'semantic-ui-react'
import VendorOrdersDropdown from '../vendor-orders/vendor-orders-dropdown'
import {sortOptions} from './options'
import {isCustomer} from '../cads/is-role'

const hideableInfo = [
  'Brand',
  'Division',
  'Category',
  'Sub-Category',
  'Sub2',
  'Color',
  'Packs',
  'Fabrication',
  'Fabric Content',
  'Sizes',
  'Description',

  "On Hand",
  "ATS",
  "Future Stock",
  "Future ATS",

  "Shipped",
  "PO",
  "Pending PO",
  "Worksheet",
  "Hold",
  "Inventory Adjustment",

  "Age",
  "Season",
  "Container #",
  "Pending Container #",
  "Ex Factory",
  "Cost",
  "Wholesale",
  "Margin",
  "MSRP",
  "Warehouse",
  "Case Pack",
  "UPC"
]

const hideableInfoCustomer = [
  'Brand',
  'Division',
  'Category',
  'Sub-Category',
  'Color',
  'Packs',
  'Fabrication',
  'Fabric Content',
  'Sizes',
  'Description',
  "Future ATS",
  "Cost",
  "Wholesale",
  "Margin",
  "MSRP"
]

const defaultFields = ['Brand', 'Color', 'Fabrication']

const fieldLabel = (fieldName) => fieldName == 'Age' ? 'Page' : fieldName

class SettingsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      checked: []
    }
  }

  onClose = () => {
    this.setState({open: false})
  }

  clickButton = () => {
    this.setState({open: true})
  }

  showAll = () => {
    let {showFields, showFieldOnChange, hideAllFields} = this.props

    if (hideableInfo.every(field => showFields.includes(field))) {
      hideAllFields()
    } else {
      hideableInfo.forEach((field) => {
        if (!showFields.includes(field)) {
          showFieldOnChange(field)
        }
      })
    }
  }

  render() {
    let {open} = this.state
    let {
      fieldOnChange, sortBy, showFields, showFieldOnChange, expandAll, expandAllOnChange,
      orgId, laFashionCombine, laFashionCombineOnChange
    } = this.props

    return (
      <React.Fragment>
        <Popup content='Settings' position='right center'
          trigger={
            <Button onClick={this.clickButton} basic circular icon='setting' style={{marginTop: '2px'}}/>
          }
        />
        <Modal size='large' open={open} onClose={this.onClose} closeIcon>
          <Modal.Header>Settings</Modal.Header>
          <Modal.Content>
            <b style={{marginBottom: '10px', display: 'block'}}>Sorting</b>

            <Grid>
              <Grid.Row columns={3}>
                <VendorOrdersDropdown
                  placeholder='Sort by'
                  name='sortBy'
                  options={sortOptions}
                  onChange={fieldOnChange}
                  value={sortBy}
                  single={true}
                />
                <Grid.Column>
                  <b style={{position: 'absolute', bottom: '45px'}}>Expand All</b>
                  <Checkbox toggle label='Expand All' checked={expandAll} onChange={expandAllOnChange}/>
                </Grid.Column>
                {
                  orgId == 5
                  ?
                  <Grid.Column>
                    <b style={{position: 'absolute', bottom: '45px'}}>LA Fashion Combine</b>
                    <Checkbox toggle label='LA Fashion Combine' checked={laFashionCombine} onChange={laFashionCombineOnChange}/>
                  </Grid.Column>
                  :
                  null
                }
              </Grid.Row>
            </Grid>

            <b style={{marginTop: '30px', display: 'block'}}>Select visible columns</b>

            <div style={{columnCount: '3', zoom: '125%', lineHeight: '200%'}}>
              {(isCustomer() ? hideableInfoCustomer : hideableInfo).map((fieldName, index) =>
                <div key={index}>
                  <Checkbox disabled={defaultFields.includes(fieldName)} label={fieldLabel(fieldName)} onChange={showFieldOnChange.bind(null, fieldName)}
                    checked={defaultFields.includes(fieldName) || showFields.includes(fieldName)}
                    style={defaultFields.includes(fieldName) ? {opacity: 0.5} : {}}
                  />
                </div>
              )}
            </div>

            <Button basic style={{padding: '5px 8px', marginTop: '10px'}} onClick={this.showAll}>show all</Button>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.onClose} primary>
              Done
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }
}

export {hideableInfo, hideableInfoCustomer, defaultFields}
export default SettingsModal
